<script setup>
import { computed } from 'vue'
import dayjs from 'dayjs'

const props = defineProps({
  detail: {
    type: Object,
    required: true
  },
  finished: {
    type: Boolean,
    default: false
  }
})

const textbook = computed(() => props.detail?.course?.displays?.textbook || [])
const textbookimg = computed(() => props.detail?.course?.displays?.textbookimg || '')
const textbookterm = computed(() => props.detail?.course?.displays?.textbookterm || [])

// PDFダウンロード期間内かどうかを判定
const isWithinTextbookTerm = computed(() => {
  if (!textbookterm.value || textbookterm.value.length < 2) return false
  
  const now = dayjs()
  const startDate = dayjs(textbookterm.value[0])
  const endDate = dayjs(textbookterm.value[1])
  
  return now.isAfter(startDate) && now.isBefore(endDate)
})
</script>

<template>
  <div
    v-if="textbook && isWithinTextbookTerm"
    class="pdfContainer"
    :class="finished ? 'finished' : ''"
  >
    <p
      v-if="finished"
      class="title"
    >
      受講済みですが再度講習テキストのPDFをダウンロードできます。<span>（クリックするとスマートフォンではダウンロード、パソコンでは別タブで開きます）</span>。
    </p>
    <p
      v-else
      class="title">
      講習テキストのPDFをダウンロードしてください
      <span>（クリックするとスマートフォンではダウンロード、パソコンでは別タブで開きます）</span>。
    </p>
    <div class="pdfContainerInner">
      <div v-if="textbookimg" class="pdfContainerInnerImg">
        <img :src="textbookimg">
      </div>
      <div class="pdfContainerInnerLink">
        <a
          v-for="(item, index) in textbook"
          :key="'textbook' + index"
          :download="item.title + '.pdf'"
          :href="item.url"
          target="_blank"
        >
          {{ item.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pdfContainer {

  &.finished {
    border: 1px solid #ddd;
    padding: 0 0 10px;
    margin: 20px auto;
  }

  .title {
    display: block;
    text-align: center;
    padding: 14px;
    background: #00008b;
    color: #FFF;
    font-size: 18px;
    margin: 0;

    span {
      font-size: 14px;
      font-weight: normal;
    }
  }

  .pdfContainerInner {
    padding: 20px 0;

    .pdfContainerInnerImg {
      flex: 0 0 auto;
      margin: 10px auto;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-height: 600px;
        max-width: 600px;
        width: auto;
        height: auto;
      }

      @media (max-width: 600px) {
        img {
          max-height: none;
          max-width: none;
          width: 100%;
          height: 100%;
        }
      }
    }

    .pdfContainerInnerLink {
      text-align: center;

      a {
        display: inline-block;
        margin: 10px 20px;
        font-size: 16px;
        color: #337ab7;
        text-decoration: underline;
      }
    }
  }
}

@media (max-width: 576px) {
  .pdfContainer {
    .pdfContainerInner {
      flex-direction: column;
      gap: 10px;

      .pdfContainerInnerImg {
        width: 100%;
        justify-content: center;
        padding: 20px 0 0;
      }

      .pdfContainerInnerLink {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style> 